MOVE.MORTGAGE.RATE_TRENDS = (function (MORTGAGE) {

  var updateTitle = function (data) {
    var selector = $(data.css_class + "-text");
    var content = JST['templates/mortgage/hp_rate_trends_title']({
      title: data.title,
      rateChangeArrow: data.rateChangeArrow,
      overallPercent: data.overallPercent,
      rateChange: ''
    });
    selector.html(content).insertBefore(data.css_class);
    selector.attr('href', data.url);
  };

  var getRatesTrendsData = function (stateCode, reFinanceRate) {
    var options = {
      state_code: stateCode,
      re_finance_rates: reFinanceRate
    };

    $.ajax({
      url: "/mrtg_handler/get_trends_data",
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(options),
      success: function (data) {
        if (data.meta.success && data.rate_trends) {
          var result = trendsData(data);
          MOVE.MORTGAGE.RATE_TRENDS_GRAPH_HELPER.drawOnMobile(result, updateTitle);
        }
      }
    });
  };

  var trendsData = function (rate) {
    var data = prepareData(rate);
    var series_data = [
      {
        showInLegend: false,
        color: '#92A0E5',
        cursor: 'default',
        marker: {
          radius: 0,
          enabled: false
        },
        states: {
          hover: {
            enabled: true
          }
        },
        point: {
          events: {
            click: function () {
              window.open(data.y30.trend_url, '_self');
            }
          }
        },
        data: data.y30.trends_data,
        min: Math.min.apply(Math, data.y30.trends_data),
        max: Math.max.apply(Math, data.y30.trends_data)
      },
      {
        showInLegend: false,
        color: '#BCDB8F',
        cursor: 'default',
        marker: {
          radius: 0,
          enabled: false
        },
        states: {
          hover: {
            enabled: true
          }
        },
        point: {
          events: {
            click: function () {
              window.open(data.y15.trend_url, '_self');
            }
          }
        },
        data: data.y15.trends_data,
        min: Math.min.apply(Math, data.y15.trends_data),
        max: Math.max.apply(Math, data.y15.trends_data)
      },
      {
        showInLegend: false,
        color: '#7BCDF3',
        cursor: 'default',
        marker: {
          radius: 0,
          enabled: false
        },
        states: {
          hover: {
            enabled: true
          }
        },
        point: {
          events: {
            click: function () {
              window.open(data.a51.trend_url, '_self');
            }
          }
        },
        data: data.a51.trends_data,
        min: Math.min.apply(Math, data.a51.trends_data),
        max: Math.max.apply(Math, data.a51.trends_data)
      }
    ];
    const trends_data = {series: series_data, title: data};
    return trends_data;
  };

  var prepareData = function (rates) {
    var baseURL = '/mortgage/rates/#location=' + $('#locationBox').val(),
      trendURL = '/mortgage/tools/mortgage-rate-trends/';
    var datasets = {
      y30: {
        trends_data: [],
        css_class: '.y30',
        title: '30-Yr Fixed',
        url: baseURL + '&iid=ldpmrtgtab30yf',
        trend_url: trendURL
      },
      y15: {
        trends_data: [],
        css_class: '.y15',
        title: '15-Yr Fixed',
        url: baseURL + '&iid=ldpmrtgtab15yf',
        trend_url: trendURL
      },
      a51: {
        trends_data: [],
        css_class: '.a51',
        title: '5/1 ARM',
        url: baseURL + '&iid=ldpmrtgtab51arm',
        trend_url: trendURL
      }
    };

    return MOVE.MORTGAGE.RATE_TRENDS_GRAPH_HELPER.mapRateTrendsData(
      datasets, rates.rate_trends
    );
  };

  MORTGAGE.RATE_TRENDS_MOBILE = {
    getRatesTrendsData: getRatesTrendsData
  };

  return MORTGAGE.RATE_TRENDS_MOBILE;
})(MOVE.MORTGAGE || {});



// WEBPACK FOOTER //
// ./mortgage/rates/rate_trends.js